import React from "react";
import { connect } from "react-redux";
import { SocialLogins as SocialLoginsView } from "../design/onboarding/SocialLogins";
import { signinActions } from "../../actions";

class SocialLogins extends React.Component {
  signInSocialApiCallback = (apiCallback, data, failedMsg) => {
    const { callback, callbackType, per_page, episode_id } = this.props;

    let callbackArgs;
    if (!this.props.callbackArgs) {
      callbackArgs = [{ page_number: 1, per_page, episode_id }];
    } else {
      callbackArgs = [
        { page_number: 1, per_page, episode_id },
        ...this.props.callbackArgs
      ];
    }

    apiCallback(data, callback, callbackType, callbackArgs, failedMsg);
  };

  signInFBApiCallback = data => {
    this.signInSocialApiCallback(
      this.props.signInFBApiCall,
      data,
      this.props.t.loginViaFbFailed
    );
  };

  signInTwitterApiCallback = data => {
    this.signInSocialApiCallback(
      this.props.signInTwitterApiCall,
      data,
      this.props.t.loginViaTwitterFailed
    );
  };

  signInGoogleApiCallback = data => {
    this.signInSocialApiCallback(
      this.props.signInGoogleApiCall,
      data,
      this.props.t.loginViaGoogleFailed
    );
  };

  signInAppleApiCallback = data => {
    this.signInSocialApiCallback(
      this.props.signInAppleApiCall,
      data,
      this.props.t.loginViaAppleFailed
    );
  };

  signInFBOnFailure = () => {
    this.props.setError(this.props.t.loginViaFbFailed);
  };

  signInTwitterOnFailure = () => {
    this.props.setError(this.props.t.loginViaTwitterFailed);
  };

  signInGoogleOnFailure = () => {
    this.props.setError(this.props.t.loginViaGoogleFailed);
  };

  signInAppleOnFailure = () => {
    this.props.setError(this.props.t.loginViaAppleFailed);
  };


  render = () => (
    <SocialLoginsView
      signInFBApiCallback={this.signInFBApiCallback}
      signInFBOnFailure={this.signInFBOnFailure}
      signInTwitterApiCallback={this.signInTwitterApiCallback}
      signInTwitterOnFailure={this.signInTwitterOnFailure}
      signInGoogleApiCallback={this.signInGoogleApiCallback}
      signInGoogleOnFailure={this.signInGoogleOnFailure}
      signInAppleApiCallback={this.signInAppleApiCallback}
      signInAppleOnFailure={this.signInAppleOnFailure}
      {...this.props}
    />
  );
}

const mapState = state => ({
  fbAppId: window.fb_app_id,
  appleClientId: window.apple_client_id,
  appleRedirectUri: window.apple_redirect_uri,
  twitterRequestTokenUrl: routes().get_twitter_token,
  twitterVerifyTokenUrl: routes().verify_twitter_token,
  callback: state.signin.callback,
  callbackType: state.signin.callbackType,
  callbackArgs: state.signin.callbackArgs,
  per_page: state.current_episode_comments.length || "",
  episode_id: state.currentEpisode.id,
  title: I18n.t("components.signInModal.socialConnect"),
  t: I18n.t("components.signInModal")
});

const mapDispatch = (dispatch, ownProps) => ({
  setError: errMsg => {
    dispatch(signinActions.setSigninError(errMsg));
    dispatch(signinActions.setSignupError([errMsg]));
  },
  signInFBApiCall: (data, callback, callbackType, callbackArgs, failedMsg) => {
    dispatch(
      signinActions.handleFBSignin(
        {
          email: data.email,
          username: data.name,
          auth_token: FB.getAccessToken(),
          auth_token_secret: null,
          auth_user_id: data.id,
          failedMsg
        },
        callback,
        callbackType,
        callbackArgs
      )
    );
  },
  signInTwitterApiCall: (
    data,
    callback,
    callbackType,
    callbackArgs,
    failedMsg
  ) => {
    dispatch(
      signinActions.handleTwitterSignin(
        {
          auth_token: data.oauth_token,
          auth_token_secret: data.oauth_token_secret,
          auth_user_id: data.user_id,
          username: data.screen_name,
          failedMsg
        },
        callback,
        callbackType,
        callbackArgs
      )
    );
  },
  signInGoogleApiCall: (
    data,
    callback,
    callbackType,
    callbackArgs,
    failedMsg
  ) => {
    dispatch(
      signinActions.handleGoogleSignin(
        {
          email: data.profileObj.email,
          auth_token: data.accessToken,
          auth_token_secret: data.tokenId,
          auth_user_id: data.googleId,
          username: data.profileObj.name,
          failedMsg
        },
        callback,
        callbackType,
        callbackArgs
      )
    );
  },
  signInAppleApiCall: (
    data,
    callback,
    callbackType,
    callbackArgs,
    failedMsg
  ) => {
    dispatch(
      signinActions.handleAppleSignin(
        {
          jwt: data.id_token,
          failedMsg
        },
        callback,
        callbackType,
        callbackArgs
      )
    );
  }
});

export default connect(mapState, mapDispatch)(SocialLogins);
